export var KEEN_VALUE = 'keen.value';
export var KEEN_KEY = 'keen.key';
export var KEEN_ELEMENTS = 'keen.elements';
export var KEEN_TABLE_INTERVAL = 'interval';
export var DEFAULT_NAME = 'Result';
export var PREFIX = '@keen.io/parser';
export var PROPERTIES_CONNECTOR = '|';
